export const INACTIVE_PROFILE = "INACTIVE_PROFILE";

export const setInactiveProfile = (isActive, message = {}) => ({
  type: INACTIVE_PROFILE,
  payload: { isActive, message },
});
